export default {
    defaultPassword: '123456',

    userType: {
        ADMIN: 1,
        ORGAN: 2,
        COLLEGE: 3,
        STUDENT: 4,
        EXPERT: 5
    },

    tempType: {
        ADMIN: 'a1nd',
        ORGAN: 'o2an',
        COLLEGE: 'c3ge',
        STUDENT: 's4ut',
        EXPERT: 'e5rt'
    },

    personType: {
         ADMIN_CONTACT : 11,         //省厅主管部门联系人 : 11,
         ADMIN_TEACHER : 12,         //通识课程师资 : 12,
         ORGAN_CONTACT : 21,         //培训基地联系人 : 21,
         ORGAN_COLLEGE_LEADER : 22,  //培训基地主管领导 : 22,
         ORGAN_PROJECT_LEADER : 23,  //培训基地培训负责人 : 23,
         ORGAN_TEACHER : 24,         //培训基地授课教师 : 24,
         ORGAN_IMPL_PERSON : 25,     //培训基地项目实施人员 : 25,
         COLLEGE_CONTACT : 31,       //院校联系人 : 31,
         STUDENT : 41,               //参训教师 : 41,
         EXPERT : 51,                //项目评审专家 : 51;
    },

    attFileCategory: {
        TEMPLATE_FILE: 1,                   // 模板文件

        BATCH_REQUIREMENT_FILE: 2,          // 项目批次需求信息附件文件
        ORGAN_DECLARE_FILE: 3,              // 基地项目申报信息附件文件
        ACHIEVEMENT_FILE: 4,                // 项目成果物附件
        CLASS_TRAINING_RESOURCE_FILE: 5,    // 教学资源文件
        PROJECT_SUMMARY_FILE: 6,            // 项目总结文件

        START_CLASS_NOTIFICATION_FILE: 10,  // 开班通知文件
        PROJECT_TRAINING_PLAN_FILE: 11,     // 项目培训方案文件
    },

    attFileType: {
        PDF_FILE: 1,
        IMAGE_FILE: 2,

        OTHER_FILE: 9,
    },

    studentState: {
        NON_VERIFY: 1,
        VERIFIED: 2,
        DISABLED: 3
    },

    userState: {
        ENABLED: 1,
        DISABLED: 2
    },


    projectBatchState: {
        V1_CREATED: 1,
        V2_PUBLISHED: 2,
        V3_VERIFY: 3,
        V4_SELECTION: 4,
        V5_CONFIRM: 5,
        V6_COMPLETED: 6,
        V9_CANCELED: 9
    },
    projectState: {
        V1_CREATED: 1,
        V2_PREPARE: 2,
        V3_VERIFY: 3,
        V4_EXECUTE: 4,
        V5_SUMMARY: 5,
        V6_COMPLETED: 6,
        V7_REPORT: 7,
        V9_CANCELED: 9
    },
    projectClassState: {
        V1_PREPARE: 1,
        V2_SIGNIN: 2,
        V3_CONFIRM: 3,
        V4_EXECUTE: 4,
        V5_COMPLETED: 5,
        V9_CANCELED: 9
    },


    studentSignInConfirmState: {
        V1_NON_CONFIRM: 1,
        V2_CONFIRM_FALSE: 2,
        V3_CONFIRM_TRUE: 3
    },
    studentClassState: {
        V1_NON_CONFIRM: 1,
        V2_CONFIRMED: 2,
        V3_CHECK_IN: 3,
        V4_COMPLETED: 4,
    },

    surveyTemplateType: {
        V1_FOR_CLASS: 1,
        V2_FOR_COURSE_TEACHER: 2,
    },
    surveyTemplateState: {
        V1_NON_PUBLISHED: 1,
        V2_PUBLISHED: 2,
        V3_DISABLED: 3
    },

    surveyTemplateItemType: {
        V1_SCORE: 1,
        V2_CONTENT: 2,
    },

    surveyPaperState: {
        NON_PUBLISHED : 1,    // 未发布
        PUBLISHED : 2,   // 已发布
        COMPLETED : 3,   // 已结束
    }
}
